<template>
  <!-- <div> -->
    <!-- <div class="header">
      <h1>体育能力综合评估</h1>
      <p>展示体育技能、体育行为、体质健康、体育意识和体育知识的占比分析</p>
    </div> -->
    
    <div class="chart-container">
      <div class="chart-wrapper">
        <div ref="chart" style="width: 100%; height: 100%;"></div>
      </div>
    </div>
    
    <!-- <div class="data-info">
      <div class="data-item" v-for="(item, index) in chartData" :key="index">
        <div class="color-indicator" :style="{background: colorList[index]}"></div>
        {{ item.name }}: {{ item.value }}%
      </div>
    </div> -->
  <!-- </div> -->
</template>

<script>
// 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'

export default {
  name: 'SportsAssessmentChart',
  data() {
    return {
      backgroundColor: 'transparent',// 透明背景

      colorList: ['#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', "rgba(250,250,250,0.5)"],
      chartData: [
        { value: 24, name: '最大压力' },
        { value: 15, name: '最小压力' },
        // { value: 27, name: '体质健康' },
        // { value: 33, name: '体育意识' },
        // { value: 9, name: '体育知识' }
      ],
      myChart: null
    }
  },
  computed: {
    avgPressure() {
    if (!this.chartData.length) return 0;
    const sum = this.chartData.reduce((acc, cur) => acc + Number(cur.value), 0);
    return (sum / this.chartData.length).toFixed(1); // 保留1位小数
  },
    chartOption() {
      return {
        title: {
          text: this.avgPressure,
          subtext: '平均压力',
          x: 'center',
          y: 'center',
          textStyle: {
            fontSize: 30,
            fontWeight: 'normal',
            color: '#fff'
          },
          subtextStyle: {
            color: '#fff',
            fontSize: 14
          },
        },
        grid: {
          bottom: 150,
          left: 0,
          right: '10%'
        },
        legend: {
          show: false,
          orient: 'vertical',
          top: "middle",
          right: "5%",
          textStyle: {
            color: '#f2f2f2',
            fontSize: 25,
          },
          icon: 'roundRect'
        },
        series: [
          // 主要展示层的
          {
            radius: ['35%', '51%'],
            center: ['50%', '50%'],
            type: 'pie',
            itemStyle: {
              normal: {
                color: (params) => {
                  return this.colorList[params.dataIndex]
                }
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 10,
                length2: 20,
                lineStyle: {
                  color: '#d3d3d3'
                },
                align: 'right'
              },
              color: "#000",
              emphasis: {
                show: true
              }
            },
            label: {
              normal: {
                    show: true,
                    formatter: (params) => {
                    // 只显示名称和百分比
                    return `{nameStyle|${params.name}} {rate|${params.value}}`;
                    },
                    padding: [0, 0, 0, 0],
                    rich: {
                    nameStyle: {
                        fontSize: 14,
                        color: "#fff",
                        align: 'left',
                        fontWeight: 'bold'
                    },
                    rate: {
                        fontSize: 16,
                        color: "#1ab4b8",
                        align: 'left',
                        fontWeight: 'bold'
                    }
                    }
                }
            },
            data: this.chartData
          },
          // 边框的设置
          {
            radius: ['47%', '51%'],
            center: ['50%', '50%'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: 'rgba(250,250,250,0.5)'
              }
            },
            data: [{
              value: 1,
            }],
          }
        ]
      }
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.myChart) {
      this.myChart.dispose()
    }
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(this.chartOption)
    },
    handleResize() {
      if (this.myChart) {
        this.myChart.resize()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  text-align: center;
  margin-bottom: 40px;
  padding: 20px;
  
  h1 {
    font-size: 32px;
    margin-bottom: 10px;
    background: linear-gradient(90deg, #afa3f5, #3bafff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  p {
    color: #666;
    font-size: 16px;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.6;
  }
}

.chart-container {
    width: 100%;
    height: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.chart-wrapper {
  width: 100%;
//   max-width: 900px;
  height: 100%;
  background: transparent;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//   padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.data-info {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
}

.data-item {
  background: transparent;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.color-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
}

@media (max-width: 768px) {
  .chart-wrapper {
    height: 500px;
    padding: 15px;
  }
  
  .header h1 {
    font-size: 26px;
  }
  
  .data-item {
    font-size: 14px;
    padding: 10px 15px;
  }
}
</style>